import { IConfigModule } from "build/types/configs";

const config: IConfigModule =
{
  "version": "2.0.0",
  "allowReferral": false,
  "filterPrizes": true,
  "comingSoon": false,
  "buttonsStart": [
    "signIn",
    "signUp",
    "facebook",
    "google"
  ],
  "positiveLogoUrls": [],
  "useSecondBackground": [],
  "imageStart": "backgroundImage",
  "welcome": "ImgBackground",
  "legalAgeDate": true,
  "captureBtnBgTransparent": true,
  "routesLinks": [
    {
      "path": "/album/redirect/Ticket/upload",
      "text": "CARGAR MI TICKET"
    },
    {
      "path": "/profile",
      "text": "Mi información",
      "small": true
    },
    {
      "path": "/help",
      "text": "¿Tienes alguna duda?",
      "small": true
    },
    {
      "path": "/terms-and-conditions",
      "text": "Ver términos y condiciones",
      "small": true
    },
    {
      "path": "/privacy-politics",
      "text": "Ver aviso de privacidad",
      "small": true
    }
  ],
  "routesHome": [
    "SolMezclasId"
  ],
  "routesProfile": [
    "information",
    "phone",
    "identificacion",
  ],
  "notAvailableFields": [
    "instagram",
    "interests",
    "consumptionCenter",
    "nickName",
    "sign",
    "address",
    "genreId",
    "neighborhood",
    "postalCode",
    "city",
    "state",
    "country",
    "street1",
    "streetNumber"
  ],
  "backgroundWhite": true,
  "trivia": {
    "showIntroduction": false,
    "interestsRequired": false,
    "dontShowButtonExchange": false
  },
  "notShowFields": [
    "instagram"
  ],
  "startPopUp": false,
  "triviaQrPopUp": true,
  "dontShowSocialLogin": true,
  "showRulesInSocial": false,
  "album": {
    "Ticket": {
      "list": {
        "urlRedirectAlbumComplete": "/home",
        "urlRedirectAlbumProgress": "/album/:id/upload"
      },
      "upload": {
        "showHowToParticipate": true,
        "validate": true,
        "isTakeFoto": true,
        "useLoaderValidate": true,
        "useCongrats": true,
        "useCongratsDirect": true,
        "howTakePhoto": true
      }
    }
  },
  "useProfilePointsHome": false,
  "modalBackgroundTrivias": true,
  "stepsNewVersion": true,
  "signUp": {
    "base": false
  },
  "profile": {
    "notShowButtonInformation": true,
    "showButtonPoints": true
  },
  "prizes": {
    "exchangeEnabled": true
  },
  "placeholderDifferent": true,
  "showModalMemorama": true,
  "loaderPulse": true
}

export default config;